import { useState } from "react";
import { Plus, Minus } from "lucide-react";

export const faqs = [
  {
    q: "How much does bookkeeping cost in New Zealand?",
    a: "Our packages start at $260–$500 per month for our Standard Service (up to 100 transactions, accounts payable & receivable, bi-monthly GST filing with IRD and standard reporting), and $650–$1,500+ per month for Growth / High-Volume clients. All prices exclude GST, and your final package is confirmed after a free consultation.",
  },
  {
    q: "Do you work with tradies and construction businesses?",
    a: "Yes. We specialise in supporting tradies, construction businesses and small businesses across New Zealand, and we understand the pace and paperwork that come with them.",
  },
  {
    q: "Can you handle GST and PAYE filing with IRD?",
    a: "Absolutely. We prepare and file your GST and PAYE returns with IRD, manage the deadlines and keep your business fully compliant so you avoid penalties.",
  },
  {
    q: "Do you offer payroll?",
    a: "Yes, as an add-on. Payroll is $15 per employee per pay run (or $150–$290 flat monthly) and covers payday filing with IRD, leave accrual tracking, KiwiSaver and holiday pay calculations.",
  },
  {
    q: "Do I need to be based in a particular city?",
    a: "No. Virtual Bookkeeping is fully remote and works with clients anywhere in New Zealand.",
  },
  {
    q: "How do I get started?",
    a: "Book a free, no-obligation 30-minute consultation through our website, or call 027 294 3625 or email info@virtualbookkeeping.co.nz. We'll confirm the right package for your business.",
  },
];

function FaqItem({ item, isOpen, onToggle, index }) {
  return (
    <div className="border border-[#E1E8E9] rounded-md bg-white overflow-hidden">
      <button
        data-testid={`faq-question-${index}`}
        onClick={onToggle}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-[#F2F7F8] transition-colors"
      >
        <span className="font-heading text-lg font-medium text-[#10242B]">
          {item.q}
        </span>
        <span className="shrink-0 inline-flex h-8 w-8 items-center justify-center rounded-md bg-[#10BFCB]/15 text-[#0DA2AD]">
          {isOpen ? <Minus size={18} /> : <Plus size={18} />}
        </span>
      </button>
      {isOpen && (
        <div
          data-testid={`faq-answer-${index}`}
          className="px-6 pb-5 -mt-1 text-[#55636B] leading-relaxed"
        >
          {item.a}
        </div>
      )}
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="mb-12">
          <h4 className="text-sm font-semibold uppercase tracking-[0.15em] text-[#0DA2AD]">
            Frequently Asked Questions
          </h4>
          <h2 className="mt-4 font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-[#10242B]">
            Answers for NZ business owners
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((item, i) => (
            <FaqItem
              key={item.q}
              item={item}
              index={i}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
